import React from 'react';
import { Edit, useForm } from '@refinedev/antd';
import { Form, Input, Select, InputNumber, Switch, Row, Col, Card } from 'antd';
import { ImageUploadField } from '../../components/ImageUploadField';
import { LocalizedContentTabs, normalizeTranslations } from '../../components/LocalizedContentTabs';

const LANG_FIELDS = [
  { key: 'name', label: 'Name', required: true },
  { key: 'description', label: 'Description', textarea: true, rows: 2 },
];

export const RestaurantEdit: React.FC = () => {
  const { formProps, saveButtonProps, queryResult } = useForm({ resource: 'restaurants' });

  return (
    <Edit resource="restaurants" saveButtonProps={saveButtonProps}>
      <Form
        {...formProps}
        layout="vertical"
        onFinish={(values: any) =>
          formProps.onFinish?.({
            ...values,
            translations: normalizeTranslations(values.translations, LANG_FIELDS, queryResult?.data?.data?.translations),
          })
        }
      >
        <Card title="Images" size="small" style={{ marginBottom: 24 }}>
          <Row gutter={24}>
            <Col>
              <Form.Item label="Logo" name="logoUrl">
                <ImageUploadField subPath="restaurant" previewWidth={120} previewHeight={120} />
              </Form.Item>
            </Col>
            <Col>
              <Form.Item label="Cover Image" name="coverImageUrl">
                <ImageUploadField subPath="restaurant" previewWidth={240} previewHeight={120} />
              </Form.Item>
            </Col>
          </Row>
        </Card>

        <Card title="Basic Info" size="small" style={{ marginBottom: 24 }}>
          <LocalizedContentTabs fields={LANG_FIELDS} showSharedDivider={false} />
          <Row gutter={16}>
            <Col span={8}>
              <Form.Item label="Cuisine Type" name="cuisineType">
                <Input />
              </Form.Item>
            </Col>
            <Col span={16}>
              <Form.Item label="Tags" name="tags">
                <Select mode="tags" placeholder="e.g. halal, vegan, fine-dining" />
              </Form.Item>
            </Col>
          </Row>
        </Card>

        <Card title="Contact & Location" size="small" style={{ marginBottom: 24 }}>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item label="Address" name="address">
                <Input />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item label="Phone" name="phone">
                <Input />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item label="Website" name="websiteUrl">
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item label="Latitude" name="latitude">
                <InputNumber style={{ width: '100%' }} min={-90} max={90} step={0.0001} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Longitude" name="longitude">
                <InputNumber style={{ width: '100%' }} min={-180} max={180} step={0.0001} />
              </Form.Item>
            </Col>
          </Row>
        </Card>

        <Row gutter={16}>
          <Col span={8}>
            <Form.Item label="Sort Order" name="sortOrder">
              <InputNumber style={{ width: '100%' }} min={0} />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="Active" name="isActive" valuePropName="checked">
              <Switch />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Edit>
  );
};
